import React, { useState } from 'react';

const Reactions = ({ reactions = [], onReactionClick, currentUserId }) => {
  const [hoveredReaction, setHoveredReaction] = useState(null);

  if (!reactions || reactions.length === 0) {
    return null;
  }

  // Get user names for tooltip (simplified - just show count for now)
  const getTooltipText = (reaction) => {
    const count = reaction.count || 0;
    const hasUserReacted = reaction.user_ids?.includes(currentUserId);
    
    if (hasUserReacted) {
      return count === 1 ? 'You reacted' : `You and ${count - 1} other${count > 2 ? 's' : ''}`;
    }
    return `${count} ${count === 1 ? 'person' : 'people'}`;
  };

  return (
    <div className="flex flex-wrap gap-1.5 mt-1">
      {reactions.map((reaction) => {
        const hasUserReacted = reaction.user_ids?.includes(currentUserId);
        
        return (
          <div
            key={reaction.emoji}
            className="relative"
            onMouseEnter={() => setHoveredReaction(reaction.emoji)}
            onMouseLeave={() => setHoveredReaction(null)}
          >
            <button
              onClick={() => onReactionClick(reaction.emoji)}
              className={`
                flex items-center gap-0.5 transition-opacity duration-150 hover:opacity-80
                ${hasUserReacted ? 'opacity-100' : 'opacity-70'}
              `}
            >
              <span className="text-sm">{reaction.emoji}</span>
              <span className="text-xs text-gray-400">{reaction.count}</span>
            </button>
            
            {hoveredReaction === reaction.emoji && (
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap z-50">
                {getTooltipText(reaction)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Reactions;
